export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/caret-down-c6768da234ea14c51e954198d037fab2.svg";